// Login'dan keyin qaytish yo'li (?redirect=). Faqat ichki panel yo'llari qabul qilinadi
// (open-redirect bo'lmasin): admin uchun /admin..., usta uchun /provider...

const AREA = { admin: /^\/admin(?:[/?#]|$)/, provider: /^\/provider(?:[/?#]|$)/ };
const DEFAULT_HOME = { admin: '/admin', provider: '/provider/orders' };

export function isSafeRedirect(path, role) {
  if (typeof path !== 'string' || !AREA[role]) return false;
  if (path.startsWith('//') || path.includes('\\') || /[\u0000-\u001f]/.test(path)) return false;
  return AREA[role].test(path);
}

// Qaytish yo'li yaroqli bo'lsa o'sha, aks holda rolning bosh sahifasi.
export function resolveRedirect(path, role) {
  return isSafeRedirect(path, role) ? path : DEFAULT_HOME[role] || '/login';
}

// Joriy manzildan login'ga yo'l: /login?redirect=<path+search>[&expired=1]
export function loginUrl({ pathname, search = '', hash = '' }, extra = '') {
  const target = `${pathname}${search}${hash}`;
  const q = [];
  if (extra) q.push(extra);
  if (target && target !== '/login') q.push(`redirect=${encodeURIComponent(target)}`);
  return `/login${q.length ? `?${q.join('&')}` : ''}`;
}
